import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'

import {
  startAutoRefresh,
  stopAutoRefresh,
  stopDelay,
} from '@pickle/pickle-shared/src/features/Auth/Auth.actions'
import showChangePasswordFormModal from '@pickle/pickle-shared/src/features/Auth/ChangePasswordFormModal'
import SettingsForm from './SettingsForm'

const formName = 'settingsForm'

const stateToProps = ({ auth: { user, allConfirmed } }) => ({
  allConfirmed,
  initialValues: {
    firstName: user.firstName,
    lastName: user.lastName,
    email: user.emailConfirmation?.value || user.username,
    phone: user.phoneConfirmation?.value || user.phone,
  },
})

const dispatchToProps = {
  startAutoRefresh,
  stopAutoRefresh,
  stopDelay,
  showChangePasswordFormModal,
}

export default connect(
  stateToProps,
  dispatchToProps
)(
  reduxForm({
    form: formName,
    enableReinitialize: true,
  })(SettingsForm)
)



// WEBPACK FOOTER //
// ./src/pages/Settings/SettingsForm.container.js